import React from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
export const Contact = () => {
  return <section id="contact" className="py-20 bg-white" data-id="element-49">
      <div className="container mx-auto px-4 md:px-6" data-id="element-50">
        <div className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-52">Get In Touch</h2>
          <div className="w-20 h-1 bg-indigo-600 mx-auto mb-6" data-id="element-53"></div>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-54">
            Have a project in mind or want to discuss a potential collaboration?
            I'd love to hear from you!
          </p>
        </div>
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-55">
          <div className="lg:w-1/3" data-id="element-56">
            <div className="bg-gray-50 p-8 rounded-lg shadow-sm h-full" data-id="element-57">
              <h3 className="text-2xl font-bold mb-6" data-id="element-58">Contact Information</h3>
              <div className="space-y-6" data-id="element-59">
                <div className="flex items-start" data-id="element-60">
                  <div className="bg-indigo-100 p-3 rounded-full mr-4" data-id="element-61">
                    <Mail className="text-indigo-600" size={20} data-id="element-62" />
                  </div>
                  <div data-id="element-63">
                    <h4 className="font-medium text-gray-800" data-id="element-64">Email</h4>
                    <a href="mailto:otoprovisual@gmail.com" className="text-indigo-600 hover:text-indigo-800 transition-colors" data-id="element-65">
                      otoprovisual@gmail.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-66">
                  <div className="bg-indigo-100 p-3 rounded-full mr-4" data-id="element-67">
                    <Phone className="text-indigo-600" size={20} data-id="element-68" />
                  </div>
                  <div data-id="element-69">
                    <h4 className="font-medium text-gray-800" data-id="element-70">Phone</h4>
                    <a href="tel:+12025550157" className="text-indigo-600 hover:text-indigo-800 transition-colors" data-id="element-71">
                      +1 (202) 555-0157
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-72">
                  <div className="bg-indigo-100 p-3 rounded-full mr-4" data-id="element-73">
                    <MapPin className="text-indigo-600" size={20} data-id="element-74" />
                  </div>
                  <div data-id="element-75">
                    <h4 className="font-medium text-gray-800" data-id="element-76">Location</h4>
                    <p className="text-gray-600" data-id="element-77">Estonia</p>
                  </div>
                </div>
              </div>
              <div className="mt-8" data-id="element-78">
                <h4 className="font-medium text-gray-800 mb-3" data-id="element-79">
                  Connect with me
                </h4>
                <div className="flex space-x-4" data-id="element-80">
                  {['twitter', 'linkedin', 'dribbble', 'behance'].map(platform => <a key={platform} href="#" className="bg-white w-10 h-10 rounded-full flex items-center justify-center shadow-sm hover:bg-indigo-600 hover:text-white transition-colors" aria-label={`Visit my ${platform} profile`} data-id="element-81"></a>)}
                </div>
              </div>
            </div>
          </div>
          <div className="lg:w-2/3" data-id="element-82">
            <form className="bg-white rounded-lg shadow-sm p-8 border border-gray-100" data-id="element-83">
              <h3 className="text-2xl font-bold mb-6" data-id="element-84">Send Me a Message</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-85">
                <div data-id="element-86">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-87">
                    Your Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition" placeholder="John Doe" data-id="element-88" />
                </div>
                <div data-id="element-89">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-90">
                    Your Email
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition" placeholder="john@example.com" data-id="element-91" />
                </div>
              </div>
              <div className="mb-6" data-id="element-92">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-93">
                  Subject
                </label>
                <input type="text" id="subject" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition" placeholder="Project Inquiry" data-id="element-94" />
              </div>
              <div className="mb-6" data-id="element-95">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-96">
                  Message
                </label>
                <textarea id="message" rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition" placeholder="Tell me about your project..." data-id="element-97"></textarea>
              </div>
              <button type="submit" className="inline-flex items-center justify-center px-6 py-3 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 transition-colors w-full md:w-auto" data-id="element-98">
                Send Message <Send size={16} className="ml-2" data-id="element-99" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
};